module.exports = __webpack_public_path__ + "img/pCredit.23b01eff.svg";